import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-591eff07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "window main" }
const _hoisted_2 = { class: "title-bar" }
const _hoisted_3 = { class: "title-bar-text" }
const _hoisted_4 = { class: "title-bar-controls" }
const _hoisted_5 = { class: "window-body" }
const _hoisted_6 = { class: "code-holder" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "status-bar" }
const _hoisted_9 = { class: "status-bar-field" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }

import { inject, ref } from "vue";
import QRToken from "@/components/QRToken.vue";
import SendTokenEmail from "@/components/SendTokenEmail.vue";
import { createUser } from "@/services/Api";
import { Pages } from "@/Pages";
import { Config } from "@/config";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateToken',
  emits: ["navigate"],
  setup(__props, { emit }) {


const config = inject<Config>("config") as Config;

let token = ref("");
let stored = ref(false);
let processing = ref(false);
let statusMessage = ref("");

function generateToken() {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const charactersLength = characters.length;

  // Start counter at 1 to get correct modulo math
  for (let counter = 1; counter <= 20; counter++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));

    if (counter % 5 == 0 && counter != 20) {
      result += "-";
    }
  }

  token.value = result;
  stored.value = false;
}

async function storeToken() {
  processing.value = true;
  try {
    stored.value = await createUser(token.value, config.ApiRootURL);
    statusMessage.value = "";
  } catch (e) {
    stored.value = false;
    if (e instanceof Error) {
      statusMessage.value = `Error: ${e.message}`;
    }
  }
  processing.value = false;
}

generateToken();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(config).ServerName) + " User Token Generator ", 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          "aria-label": "Help",
          title: "Help",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('navigate', _unref(Pages).Help)))
        }),
        _createElementVNode("button", {
          "aria-label": "Close",
          title: "Close",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('navigate', _unref(Pages).Root)))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("pre", null, _toDisplayString(_unref(token)), 1),
      _createElementVNode("p", _hoisted_6, [
        _createVNode(QRToken, { token: _unref(token) }, null, 8, ["token"])
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("button", {
          type: "button",
          disabled: _unref(processing),
          onClick: storeToken
        }, " Create ", 8, _hoisted_7),
        _createVNode(SendTokenEmail, {
          token: _unref(token),
          disabled: !_unref(stored)
        }, null, 8, ["token", "disabled"])
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("button", {
          type: "button",
          onClick: generateToken
        }, "Renew")
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (!_unref(processing))
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Ready"))
          : (_openBlock(), _createElementBlock("span", _hoisted_11, " Creating...")),
        (_unref(statusMessage).length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(statusMessage)), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})